import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    marginBottom: 12,
    marginTop: 20,
  },
  title: {
    fontSize: 16,
    color: '#1C1C1E',
    fontWeight: '700',
  },
  required: {
    color: '#B04B3A',
    fontSize: 14,
  },
});
